if (!window.PrimeNewsletterReady) {
  window.PrimeNewsletterReady = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.newsletter__customer-form');
    if (!form) return;

    event.preventDefault();
    if (!form.reportValidity() || form.getAttribute('aria-busy') === 'true') return;

    const status = form.querySelector('[data-newsletter-status]');
    const fields = form.querySelector('.newsletter__fields');
    const button = form.querySelector('[type="submit"]');
    const originalLabel = button?.textContent;

    form.setAttribute('aria-busy', 'true');
    if (button) {
      button.disabled = true;
      button.textContent = 'Enviando…';
    }
    if (status) {
      status.hidden = true;
      status.textContent = '';
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('No pudimos registrar tu correo. Inténtalo de nuevo.');

      if (fields) fields.hidden = true;
      if (status) {
        status.textContent = 'Gracias por suscribirte.';
        status.hidden = false;
        status.focus();
      }
      form.reset();
    } catch (error) {
      if (status) {
        status.textContent = error.message;
        status.hidden = false;
      }
    } finally {
      form.removeAttribute('aria-busy');
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  }, true);
}
